import React from "react";

const SendTagEmailIcon = ({
  width = 14,
  height = 14,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    className={className}
  >
    <path
      d="M13.4426 0.335514C13.1368 0.0297359 12.6915 -0.0760419 12.2826 0.0555136L0.795509 3.74796C0.359065 3.8884 0.0568425 4.25818 0.00706467 4.71418C-0.0427131 5.16929 0.173287 5.59596 0.568842 5.82618L4.6364 8.19862L8.15018 4.68396C8.41062 4.42351 8.83284 4.42351 9.09329 4.68396C9.35373 4.9444 9.35373 5.36662 9.09329 5.62707L5.57862 9.14174L7.95106 13.2093C8.15995 13.5666 8.52884 13.7773 8.93506 13.7773C8.97773 13.7773 9.02129 13.7746 9.06484 13.7702C9.51995 13.7204 9.89062 13.4182 10.0302 12.9826L13.7235 1.4964C13.8551 1.08485 13.7475 0.640403 13.4426 0.335514Z"
      fill="currentColor"
    />
  </svg>
);

export default SendTagEmailIcon;
